import { useQuery } from "@tanstack/react-query";

import { ApplicantService } from "@/services/applicant";
import { Applicant } from "@/services/applicant/types";
import { useAuthStore } from "@/stores/useAuthStore";

interface UseApplicantProps {
  applicantId?: string;
  applicantPhoneNumber?: string;
}

interface UseApplicantReturn {
  data?: Applicant;
  isLoading: boolean;
  isError: boolean;
  refetch: () => Promise<{ data?: Applicant }>;
}

export const getApplicantQueryKey = (id?: string, phoneNumber?: string) => ["applicant", id || phoneNumber];

export const useApplicant = ({ applicantId, applicantPhoneNumber }: UseApplicantProps): UseApplicantReturn => {
  const { isLoggedIn } = useAuthStore();

  return useQuery({
    queryKey: getApplicantQueryKey(applicantId, applicantPhoneNumber),
    queryFn: async () => {
      if (applicantId) {
        return ApplicantService.getApplicantById(applicantId);
      } else if (applicantPhoneNumber) {
        return ApplicantService.getApplicantByPhoneNumber(applicantPhoneNumber);
      }
      throw new Error("Either applicantId or applicantPhoneNumber must be provided");
    },
    enabled: isLoggedIn && !!(applicantId || applicantPhoneNumber),
    staleTime: Infinity,
  });
};
